export default {
    intro: ({ values }: { values: { isAuto: boolean; questionTime: number; answerTime: number } }) => {
        const { isAuto, questionTime, answerTime } = values;
        if (isAuto) {
            return `${answerTime}초 동안 문제를 확인하고, ${questionTime}초 동안 참 거짓을 골라보세요!`;
        } else {
            return '문제를 보고 O/X를 골라보세요!';
        }
    },
    options: {
        auto: '자동 진행',
        manual: '수동 진행',
        timer: '타이머 설정',
        answerTime: '문제 확인 시간',
        questionTime: '정답 선택 시간',
        answerCheckTime: '정답 확인 시간',
        showOtherAvatar: '모든 아바타 보여주기',
        showOtherAvatarDescription: '학생 화면에서 OX 선택 중 다른 학생의 아바타를 보여줄지 선택합니다.',
    },
    topbar: {
        check: '문제를 확인해주세요.',
        question: '정답을 선택해주세요.',
        result: '정답 공개!',
        default: '재미있는 OX 퀴즈',
    },
    buttons: {
        standby: '문제 공개',
        question: '선택 마감 및 정답 공개',
        check: '선택 시작',
        unclickUser: {
            unselect: '미선택<br />인원 보기',
            allSelect: '모두 <br />선택했어요!',
            count: '{count}명',
        },
    },
    modal: {
        unselect: '선택하지 않은 학생',
        timerError: 'OX 퀴즈를 자동 모드로 시작하려는 경우,<br>3개의 타이머를 모두 설정해 주세요.',
    },
    toast: {
        unselect: '답을 고르기 전, 문제를 먼저 확인해 보세요!',
    },
    standbyStep: ({ values }: { values: { index: number } }) => {
        const { index } = values;
        const messages = ['풍선에<br />공기 주입 중...', '열기구<br />데우는 중...', '안전점검<br />하는 중...'];

        return messages[index];
    },
    resultStep: {
        result: '정답은 <i></i>입니다.',
        nextQuestion: '{time}초 뒤 다음 문제 시작!',
    },
    autoMode: '자동 모드로 진행중입니다.',
    questionAccuracy: {
        content: ({ values }: { values: { questionText: string; correctChoice: boolean } }) => {
            const { questionText, correctChoice } = values;
            return `${questionText} <strong>${correctChoice ? '(O: 참)' : '(X: 거짓)'}</strong>`;
        },
    },
    correctChoice: {
        true: '참',
        false: '거짓',
    },
    question: '문제',
    answer: '정답',
    explanation: '해설',
    additionalMaterial: '추가 자료',
    explanationMaterial: '해설 자료',
    table: {
        question: '문제',
        answerRate: '정답률',
    },
    isAnswer: '정답은?',
    roundNumber: '{number}번',
    timer: {
        remaining: '{count}초',
    },
};
